import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';
import { CookieStorage } from '@aws-amplify/core';
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, HttpBackend } from '@angular/common/http';
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { enGB } from 'date-fns/locale/en-GB';
import { provideLoginService } from 'login';
import { AppComponent } from './app/app.component';
import routes from './app/app.routes';
import { ENV } from './providers/environment.provider';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { ApiInterceptorService } from './app/services/api-interceptor/api-intecerceptor.service';

if (environment.production) {
  enableProdMode();
}

// Configure amplify 
Amplify.configure({ Auth: { Cognito: environment.cognitoConfig } });
cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({ sameSite: 'none' }));

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptorService, multi: true },
    { provide: ENV, useValue: environment },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always', appearance: "outline" } },
    { provide: MAT_DATE_LOCALE, useValue: enGB },
    { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    provideLoginService({
      licenseServerUrl: environment.licenseServerURL
    })
  ],
}).catch(err => console.error(err));

// AoT requires an exported function for factories
export function HttpLoaderFactory(handler: HttpBackend): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(handler, [
    { prefix: './assets/i18n/', suffix: '.json' },
    { prefix: './assets/i18n/framework/', suffix: '.json' },
    { prefix: './assets/i18n/pages/not-found/', suffix: '.json' },
    { prefix: './assets/i18n/pages/assets/', suffix: '.json' },
    { prefix: './assets/i18n/pages/configuration/', suffix: '.json' },
    { prefix: './assets/i18n/pages/reports/', suffix: '.json' },
    { prefix: './assets/i18n/pages/previous-valuations/', suffix: '.json' },
    { prefix: './assets/i18n/pages/pricing/', suffix: '.json' },
    { prefix: './assets/i18n/pages/not-authorised/', suffix: '.json' },
  ])
}